<div #galleryContainer class="galleryContainer" (mousedown)="startDragging($event)" (mouseup)="stopDragging($event)" (mouseleave)="stopDragging($event)" (mousemove)="moveEvent($event)">
  @for (imagen of imagenes; track imagen; let i = $index) {
    <div #divImg class="img" (click)="onClickedImage(i)">
      <img [src]="imagen" alt="imagen" loading="lazy" draggable="false" />
    </div>
  }

  @if (numeroImagenes > 1) {
    <div class="arrow-container previous" (click)="scrollBy(-1)">
      <mat-icon class="arrowicon arrow">chevron_left</mat-icon>
    </div>
  }
  @if (numeroImagenes > 1) {
    <div class="arrow-container next" (click)="scrollBy(1)">
      <mat-icon class="arrowicon arrow">chevron_right</mat-icon>
    </div>
  }
</div>
